import React, { useEffect } from 'react';
import { Row, Col } from 'antd';
import './LeftFeature.css';
import Aos from 'aos';
import 'aos/dist/aos.css';

export const LeftFeature = ({ features, animeSrc, animeQuote, animeName, imageSrc, title, description, animation, isMobile }) => {
    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);

    return (
        <div className={`left-feature ${isMobile ? "mobile-padding" : "desktop-padding"}`}>
            <Row className={`left-feature-row ${isMobile ? "mobile-left-feature" : "desktop-left-feature"}`}>
                {!isMobile && 
                <Col span={6} data-aos="fade-right" className="left-feature-message">
                    <img src={animeSrc} alt="Anime_Img" className="left-feature-message-image"/>
                    <p className="message">"{animeQuote}" - {animeName}</p>
                </Col>}
                <Col span={isMobile ? 24 : 9} className='left-feature-text'  data-aos="fade-left">
                    <h1 className="left-title">{title}</h1>
                    <ul>
                        <li>
                            <p className="left-content">{features[0]}</p>
                        </li>
                        <li>
                            <p className="left-content">{features[1]}</p>
                        </li>
                        <li>
                            <p className="left-content">{features[2]}</p>
                        </li>
                        <li>
                            <p className="left-content">{features[3]}</p>
                        </li>
                    </ul>
                </Col>
                <Col span={isMobile ? 24 : 9} className="intro-image" data-aos={animation}>
                    <img src={imageSrc} alt={animeName} className={`responsive-image ${isMobile ? "mobile-margin" : "desktop-margin"}`} />
                </Col>
            </Row>
            <div className="horizontal-line"></div>
        </div>
    );
};